/** Stripe renews on the anniversary day, clamping to the last day of shorter months. */
export function nextMonthlyBillingDate(start: Date): Date {
    const next = new Date(start);
    next.setUTCDate(1);
    next.setUTCMonth(next.getUTCMonth() + 1);
    const lastDay = new Date(Date.UTC(next.getUTCFullYear(), next.getUTCMonth() + 1, 0)).getUTCDate();
    next.setUTCDate(Math.min(start.getUTCDate(), lastDay));
    return next;
}

export function billingDayLabel(day: number): string {
    const suffix = day >= 11 && day <= 13 ? "th" : ({ 1: "st", 2: "nd", 3: "rd" }[day % 10] ?? "th");
    return `${day}${suffix}`;
}
